import { Link, useLocation } from "react-router-dom";
import { LogoMark } from "@/components/LogoMark";
import { TOKEN_KEY } from "@/lib/api";
import { LANGS, getLang, switchLang } from "@/i18n";

export const SiteHeader = () => {
  const loc = useLocation();
  const token = localStorage.getItem(TOKEN_KEY);
  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-[#FAF8F5]/80 border-b border-[#1C242B]/10 no-print">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="header-home-link" className="flex items-center gap-2.5 group">
          <LogoMark className="w-9 h-9 transition-transform duration-300 group-hover:rotate-90" />
          <span data-no-translate className="font-display font-bold text-[13px] sm:text-base tracking-tight text-[#1C242B] leading-tight">
            Aptitude<span className="text-[#D96B43]"> Plus</span>
          </span>
        </Link>
        <nav className="flex items-center gap-2 sm:gap-5 text-sm">
          <select data-testid="language-select" data-no-translate aria-label="Language" value={getLang()} onChange={(e) => switchLang(e.target.value)}
            className="rounded-full border border-[#1C242B]/15 bg-white px-2.5 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#D96B43]/40">
            {LANGS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
          </select>
          <Link to="/careers" data-testid="header-explore-link" className="hidden sm:inline text-slate-600 hover:text-[#1C242B] transition-colors">Explore careers</Link>
          <a href="/#how" data-testid="header-how-link" className="hidden md:inline text-slate-600 hover:text-[#1C242B] transition-colors">How it works</a>
          <a href="/#mission" data-testid="header-mission-link" className="hidden md:inline text-slate-600 hover:text-[#1C242B] transition-colors">Mission</a>
          {token && loc.pathname === "/" && (
            <Link to="/assessment" data-testid="header-resume-link" className="text-[#3E6B5C] font-medium hover:underline">Resume</Link>
          )}
          <Link
            to="/assessment"
            data-testid="header-start-test-btn"
            className="whitespace-nowrap rounded-full bg-[#D96B43] text-white px-4 sm:px-5 py-2 font-medium hover:bg-[#C05630] transition-colors"
          >
            <span className="sm:hidden">Start test</span><span className="hidden sm:inline">Take the free test</span>
          </Link>
        </nav>
      </div>
    </header>
  );
};
